import { useQuery } from '@tanstack/react-query';
import { actionItemsApi } from './api';

export const ACTION_ITEMS_KEY = 'action-items';

/**
 * Fetch action items for the current tenant
 * Note: Real-time updates are handled via WebSocket events
 */
export function useActionItems() {
  return useQuery({
    queryKey: [ACTION_ITEMS_KEY],
    queryFn: () => actionItemsApi.list(),
    // No polling - updates come via WebSocket
    // Only refetch on mount, focus, and manual invalidation
    staleTime: Infinity,
  });
}
